module.exports = __webpack_public_path__ + "static/media/hero.81d57c29.jpg";